import { all } from 'redux-saga/effects'
import watcherUserSaga from './RequestsHandlers/userRequestsHandlers'
import watcherProfileSaga from './RequestsHandlers/profileRequestHandler'
import watcherCallReportSaga from './RequestsHandlers/callReportRequestHandler'
import watcherTeamMembersSaga from './RequestsHandlers/teamMembersRequestHandler'
import watcherDomainSaga from './RequestsHandlers/domainRequestHandler'
import watcherGetAllUsersSaga from './RequestsHandlers/getAllUsersRequestHandler'
import watcherAdminUsersSaga from './RequestsHandlers/accessibilityRequestHandler'
import watcherAllPackagesSaga from './RequestsHandlers/packagesRequestHandler'
import watcherTransactionSaga from './RequestsHandlers/transactionRequestHandler'
import watcherSettingsSaga from './RequestsHandlers/settingsRequestHandler'
import watcherSupportSaga from './RequestsHandlers/supportRequestHandler'
import watcherDashboardSummerySaga from "./RequestsHandlers/dashboardSummeryRequestHandler"
import watcherTenantMemberSaga from './RequestsHandlers/tenantMemberRequestHandler'

export default function* rootSaga() {
  yield all([
    watcherUserSaga(),
    watcherProfileSaga(),
    watcherCallReportSaga(),
    watcherTeamMembersSaga(),
    watcherDomainSaga(),
    watcherGetAllUsersSaga(),
    watcherAdminUsersSaga(),
    watcherAllPackagesSaga(),
    watcherTransactionSaga(),
    watcherSettingsSaga(),
    watcherSupportSaga(),
    watcherDashboardSummerySaga(),    
    watcherTenantMemberSaga()
  ])
}
